import { withStyles, WithStyles } from "@mui/styles";
import cardBodyStyle from "assets/jss/mui-extras/cardBodyStyle";
import classNames from "classnames";
import * as React from "react";

interface IProps {
    className?: string;
    profile?: boolean,
    plain?: boolean
}

type Props = IProps & WithStyles<typeof cardBodyStyle>;

const MuiCardBody: React.FC<Props> = (props) => {

    const { classes, className, children, plain, profile, ...rest } = props;
    const cardBodyClasses = classNames({
        [classes.cardBody]: true,
        [classes.cardBodyPlain]: plain,
        [classes.cardBodyProfile]: profile,
        [className]: className !== undefined
    });
    return (
        <div className={cardBodyClasses} {...rest}>
            {children}
        </div>
    );
}


export default withStyles(cardBodyStyle)(MuiCardBody);
